import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./index.module.css";
import { Editor } from "@/03-widgets/editor";
import { Path } from "@/03-widgets/path";
import { SearchBar } from "@/03-widgets/search-bar";
import { Topbar } from "@/03-widgets/topbar";
import { useNavigate } from "react-router";
const EditPage = ({ documentId, path }) => {
    const navigate = useNavigate();
    return (_jsxs("div", Object.assign({ className: styles.pageWrapper }, { children: [_jsx(Topbar, { children: _jsx(SearchBar, {}) }), _jsxs("div", Object.assign({ className: styles.editorWrapper }, { children: [_jsx(Path, { path: path, onNavigate: (id) => navigate(id === null ? "/" : `/${id}`) }), _jsx(Editor, { documentId: documentId })] }))] })));
};
export default EditPage;
